import { metrics } from '@atlassian/browser-metrics/factory';
import type { Metric } from '@atlassian/browser-metrics/metric';

export const embeddedViewToEditTransitionMetric = (): Metric =>
	metrics.interaction({
		key: 'embedded-confluence-view-to-edit-transition',
	});
